"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAvatar = IconAvatar;
exports["default"] = exports.SimpleAvatar = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function makeContainerStyles(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? true : _ref$rounded;
  return (0, _classnames["default"])('flex items-center justify-center border', 'font-semibold uppercase text-gray-light overflow-hidden', {
    'rounded-full': rounded
  }, className);
}
var SimpleAvatar = exports.SimpleAvatar = function SimpleAvatar(_ref2) {
  var src = _ref2.src,
    alt = _ref2.alt,
    className = _ref2.className,
    fallback = _ref2.fallback,
    _ref2$rounded = _ref2.rounded,
    rounded = _ref2$rounded === void 0 ? true : _ref2$rounded,
    _ref2$mode = _ref2.mode,
    mode = _ref2$mode === void 0 ? 'contain' : _ref2$mode,
    _ref2$scale = _ref2.scale,
    scale = _ref2$scale === void 0 ? 1 : _ref2$scale;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];

  // Reset error and loading state if `src` changes
  (0, _react.useEffect)(function () {
    setError(false);
    setLoading(true);
    if (!!src) {
      var image = new Image();
      image.onload = function () {
        return setLoading(false);
      };
      image.onerror = function () {
        setError(true);
        setLoading(false);
      };
      image.src = src;
    } else {
      setLoading(false);
      setError(true);
    }
  }, [src]);
  var props = (0, _react.useMemo)(function () {
    alt = alt || '';
    var placeholder = fallback || (!(0, _isNil["default"])(alt) && alt.length > 0 ? alt.slice(0, 2) : '?');
    var children = error ? placeholder : /*#__PURE__*/_react["default"].createElement("img", {
      src: src,
      alt: alt,
      className: (0, _classnames["default"])('h-full w-full', mode === 'cover' ? 'object-cover' : 'object-contain'),
      style: {
        transform: "scale(".concat(scale, ")")
      }
    });
    var classnames = makeContainerStyles({
      rounded: rounded,
      className: (0, _classnames["default"])('w-full h-full', className)
    });
    if (loading) {
      return {
        className: classnames
      };
    }
    return {
      className: (0, _classnames["default"])(classnames, 'bg-gray-divider'),
      children: children
    };
  }, [loading, error, fallback, alt, src, rounded]);
  return /*#__PURE__*/_react["default"].createElement("div", props);
};
var Avatar = function Avatar(props) {
  var className = props.className,
    _props$isSizeCls = props.isSizeCls,
    isSizeCls = _props$isSizeCls === void 0 ? false : _props$isSizeCls;
  return /*#__PURE__*/_react["default"].createElement(SimpleAvatar, (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('flex-shrink-0', className, {
      '!h-12 !w-12': !isSizeCls
    })
  }));
};
var Wrapper = function Wrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: makeContainerStyles(_objectSpread(_objectSpread({}, props), {}, {
      className: (0, _classnames["default"])('w-12 h-12 flex-shrink-0', props.className)
    }))
  }));
};
function IconAvatar(_ref3) {
  var icon = _ref3.icon,
    _ref3$containerProps = _ref3.containerProps,
    containerProps = _ref3$containerProps === void 0 ? {} : _ref3$containerProps;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, containerProps, icon);
}
var _default = exports["default"] = Avatar;
//# sourceMappingURL=index.js.map